<div class="title-line md:mb-5">
  <rk-icon-button
    class="hidden md:inline-block"
    (click)="backToPrograms()"
    [bordered]="true"
    [size]="24"
    faIcon="fa-arrow-left"
  ></rk-icon-button>
  <div
    class="w-8 md:w-2.5 aspect-square rounded md:rounded-sm ml-0 md:ml-3.5 mr-2.5"
    [style.background]="program.color"
  ></div>
  <div
    class="title font-bold md:font-normal text-ellipsis whitespace-nowrap overflow-hidden mr-4"
  >
    {{ program.name }}
  </div>
  <div class="md:hidden" (click)="editProgram()">
    <mat-icon class="" fontSet="fa" fontIcon="fa-pen"></mat-icon>
  </div>
</div>
<div class="actions hidden md:flex">
  <rk-button
    class="mr-2.5"
    [faIcon]="'fa-plus'"
    [label]="'SCHEDULE.PROGRAMS.ADD_PLAYLIST' | translate"
    [disabled]="!(hasPlaylists$ | async)"
    rkTooltip
    [tooltipDescription]="'SCHEDULE.PROGRAMS.NO_PLAYLIST' | translate"
    [tooltipDisabled]="hasPlaylists$ | async"
    (click)="addPlaylist()"
  ></rk-button>
  <rk-button
    [btnStyle]="'orange'"
    [matMenuTriggerFor]="actionsMenu"
    [svgIcon]="'dot-down'"
    (click)="placeMatMenu()"
  ></rk-button>
</div>
<div class="infos hidden md:flex">
  <ng-container *ngIf="program.playlistsNumber > 0">
    {{
      'SCHEDULE.PROGRAMS.PLAYLISTS_NUMBER' | translate: { count: program.playlistsNumber }
    }}
    -
    {{
      'SCHEDULE.PROGRAMS.ESTIMATED_DURATION'
        | translate: getMinutesAndHours(program.estimatedDuration)
    }}
  </ng-container>
</div>

<mat-menu #actionsMenu="matMenu" [overlapTrigger]="false">
  <ng-container>
    <button mat-menu-item (click)="editProgram()">
      <mat-icon fontSet="fa" fontIcon="fa-pen"></mat-icon>
      <span translate>MEDIA.CONTEXT_MENU.EDIT</span>
    </button>
    <button mat-menu-item (click)="duplicateProgram()">
      <mat-icon fontSet="fa" fontIcon="fa-clone"></mat-icon>
      <span translate>MEDIA.CONTEXT_MENU.DUPLICATE</span>
    </button>
    <div class="menu-separator"></div>
    <button mat-menu-item (click)="deleteProgram()">
      <mat-icon fontSet="fa" fontIcon="fa-trash"></mat-icon>
      <span translate>MEDIA.CONTEXT_MENU.DELETE</span>
    </button>
  </ng-container>
</mat-menu>
